<template>
<div class="loading_container">
  <div v-if="!isLoadingFeed">
    <!-- <svg @click="closePage" class="back_icon" xmlns="http://www.w3.org/2000/svg" overflow="hidden" viewBox="0 0 48 48" style="width:1em;height:1em;vertical-align:middle"><path fill-rule="nonzero" d="M33.39 4.558a1.976 1.976 0 0 0-2.684-.063l-.124.119-15.196 15.918a5.026 5.026 0 0 0-.164 6.75l.163.18 15.197 15.924c.76.796 2.017.821 2.808.056.75-.725.811-1.9.17-2.698l-.114-.13L18.249 24.69a1.005 1.005 0 0 1-.078-1.293l.079-.093L33.446 7.386a2.01 2.01 0 0 0-.056-2.828z"/></svg> -->
    <div class="back_icon"></div>
    <div class="rules">
      <div class="rules_right"></div>
    </div>
    <div class="title"></div>
    <div class="sub_title"></div>
    <div class="content1"></div>
    <div class="content2"></div>
    <div class="types">
      <div class="type">
        <img :src="typeBackImgUnselected3" />
        <div class="title"></div>
      </div>
      <div class="type">
        <img :src="typeBackImgUnselected3" />
        <div class="title"></div>
      </div>
      <div class="type">
        <img :src="typeBackImgUnselected3" />
        <div class="title"></div>
      </div>
    </div>
    <div class="category_list">
      <div class="cate1"></div>
      <div class="cate2"></div>
      <div class="cate3"></div>
      <div class="cate4"></div>
    </div>
  </div>
  <div class="feed">
    <div class="container">
      <div class="shop_background"></div>
      <div class="shop_column">
        <div class="shop_img"></div>
        <div class="shop_name"></div>
        <div class="shop_desc"></div>
      </div>
    </div>
    <div class="container">
      <div class="shop_background"></div>
      <div class="shop_column">
        <div class="shop_img"></div>
        <div class="shop_name"></div>
        <div class="shop_desc"></div>
      </div>
    </div>
    <div class="container">
      <div class="shop_background"></div>
      <div class="shop_column">
        <div class="shop_img"></div>
        <div class="shop_name"></div>
        <div class="shop_desc"></div>
      </div>
    </div>
    <div v-for="(feed, index) in new Array(7)" :key="index" class="container">
      <div class="shop_background"></div>
      <div class="shop_column">
        <div class="shop_img"></div>
        <div class="shop_name"></div>
        <div class="shop_desc"></div>
      </div>
    </div>
    
  </div>
</div>
</template>
<script>
export default {
  props: {
    isLoadingFeed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    
  },
  data() {
    return {
      typeBackImgUnselected3: 'https://img0.didiglobal.com/static/soda_public/do1_zuwVrHqtdM9swEvuZ9bE'
    }
  },
  computed: {},
  methods: {
    closePage() {
      this.SodaBridge('closePage');
    },
  }
}
</script>
<style lang="scss" scoped>
.loading_container {
  padding-left: 32px;
  padding-right: 32px;
  overflow: hidden;
  .back_icon {
    margin-top: 115px;
    margin-left: 14px;
    width: 18.97px;
    height: 33.99px;
  }
  .rules {
    margin-top: 39px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-left: 20px;
    .rules_right {
      width: 120.12px;
      height: 46px;
      background: rgba(0,0,0,0.08);
      border-radius: 23px 0px 0px 23px;
    }
  }
  .title {
    margin-top: 5px;
    width: 350px;
    height: 54px;
    opacity: 0.08;
    background: #000000;
    border-radius: 18px;
  }
  .sub_title {
    margin-top: 13px;
    width: 194px;
    height: 54px;
    opacity: 0.08;
    background: #000000;
    border-radius: 18px;
  }
  .content1 {
    margin-top: 37px;
    width: 344px;
    height: 24px;
    opacity: 0.08;
    background: #000000;
    border-radius: 14px;
  }
  .content2 {
    margin-top: 7px;
    width: 195px;
    height: 24px;
    opacity: 0.08;
    background: #000000;
    border-radius: 14px;
  }
  .types {
    margin-top: 104px;
    display: flex;
    justify-content: space-around;
    .type {
      position: relative;
      img {
        width: 216px;
        height: 184px;
      }
      .title {
        position: absolute;
        bottom: 20px;
        left: 48px;
        width: 120px;
        height: 28px;
        opacity: 0.08;
        background: #000000;
        border-radius: 14px;
      }
    }
  }
  .category_list {
    margin-top: 32px;
    width: fit-content;
    display: flex;
    overflow-x: auto;
    .cate1 {
      width: 166px;
      height: 72px;
      opacity: 0.08;
      background: #000000;
      border-radius: 18px;
    }
    .cate2 {
      margin-left: 20px;
      width: 208px;
      height: 72px;
      opacity: 0.08;
      background: #000000;
      border-radius: 18px;
    }
    .cate3 {
      margin-left: 20px;
      width: 229px;
      height: 72px;
      opacity: 0.08;
      background: #000000;
      border-radius: 18px;
    }
    .cate4 {
      margin-left: 20px;
      width: 229px;
      height: 72px;
      opacity: 0.08;
      background: #000000;
      border-radius: 18px;
    }
  }
  .feed {
    margin-top: 48px;
    .container {
      margin-bottom: 24px;
      position: relative;
      .shop_background {
        width: 686px;
        height: 524px;
        opacity: 0.08;
        background: #000000;
        border-radius: 40px;
      }
      .shop_column {
        position: absolute;
        top: 24px;
        padding-left: 24px;
        .shop_img {
          left: 24px;
          width: 638px;
          height: 320px;
          opacity: 0.08;
          background: #000000;
          border-radius: 28px;
        }
        .shop_name {
          margin-top: 21px;
          width: 370px;
          height: 32px;
          opacity: 0.08;
          background: #000000;
          border-radius: 21px;
        }
        .shop_desc {
          margin-top: 12px;
          width: 258px;
          height: 32px;
          opacity: 0.08;
          background: #000000;
          border-radius: 21px;
        }
      }
    }
  }
}
</style>